import React from "react";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import SortHealthInsureProduct from "../../Components/Modals/SortHealthInsureProduct";
import { Search } from "@mui/icons-material";
import useSelectedProductCard from "./useSelectedProductCard";
import ProductCard from "../../Components/PersonalAccidentComponents/ProductCard/ProductCard";
import NoProductFound from "../../Components/PersonalAccidentComponents/NoProductFound/NoProductFound";
import useProductListing from "./useProductListing";
import { Alert, Snackbar } from "@mui/material";
import ButtonGroupFooter from "../../Components/PersonalAccidentComponents/ButtonGroupFooter/ButtonGroupFooter";

export default function ProductListingPage() {
  const {
    productList,
    handleOnBack,
    handleSearch,
    handleSort,
    handleCloseSort,
    handleSortByPremium,
    handleOnBuy,
    loading,
  } = useProductListing();

  // Handles the selection of product card
  const { activeIndex, handleSelectProductCard } = useSelectedProductCard();

  return (
    <div>
      <div>
        {/* Category header */}
        <CategoryHeader title="Plan Suggested For You" />
      </div>
      <div>
        <div className="form-container mb-3">
          <div className="searchbox_container">
            {/* Search layout */}
            <SearchLayout handleSearch={handleSearch} />

            <SortButton handleSort={handleSort} />
            {/* TODO: To be changed */}
            <SortHealthInsureProduct
              open={false}
              close={handleCloseSort}
              sortByPremium={handleSortByPremium}
            />
          </div>
          <div>
            {productList && productList.length > 0 ? (
              productList.map((item, index) => (
                <ProductCard
                  product={item}
                  key={index}
                  onClick={() => handleSelectProductCard(index)}
                  isActive={index === activeIndex}
                />
              ))
            ) : (
              <NoProductFound />
            )}
          </div>
        </div>
      </div>
      <ButtonGroupWithProgressIndicator
        disabled={activeIndex === null}
        handleOnBack={handleOnBack}
        handleOnBuy={() => handleOnBuy(activeIndex)}
        loading={loading}
      />
    </div>
  );
}

const ButtonGroupWithProgressIndicator = ({
  disabled,
  handleOnBack,
  handleOnBuy,
  loading,
}) => {
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleBuyClick = () => {
    if (disabled) {
      setSnackbarOpen(true);
    } else {
      handleOnBuy();
    }
  };
  return (
    <div className="">
      <ButtonGroupFooter
        isLoading={loading}
        handleLeftButtonClick={handleOnBack}
        handleRightButtonClick={handleBuyClick}
        rightButtonText="Buy Now"
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="warning"
          sx={{ width: "100%" }}
        >
          Please select one product to proceed.
        </Alert>
      </Snackbar>
    </div>
  );
};

const SearchLayout = ({ handleSearch }) => {
  return (
    <div className="search_box">
      <Search className="searchIcon" />
      <input
        type="search"
        className="input_searchbox"
        placeholder="Search for plans"
        onChange={handleSearch}
      />
    </div>
  );
};

const SortButton = ({ handleSort }) => {
  return (
    <button className="sort_btn" onClick={handleSort}>
      sort
    </button>
  );
};
